<template>
  <div class="AddLessonContentModal">
    <el-dialog
        :title="dialogTitle"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        @opened="handleOpen"
    >

      <div style="display: flex; align-items: center">
        <p>所属模块:</p>
        <el-select style="margin-left: 40px" v-model="formData.modelId">
          <el-option
              v-for="item in editOutLineDetail.outline"
              :key="item.id"
              :label="item.module"
              :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div style="display: flex; align-items: center">
        <p>选择内容类型:</p>
        <el-radio-group style="margin-left: 40px" v-model="lessonContentType">
          <el-radio
              v-if="formData.modelId===1"
              v-for="item in [{value:'content',label:'课程正文'}]"
              :key="item.value"
              :label="item.value"
          >{{ item.label }}
          </el-radio>
          <el-radio
              v-else-if="formData.modelId===2"
              v-for="item in contentTypeArr"
              :label="item.value"
          >{{ item.label }}
          </el-radio>
          <el-radio
              v-else
              v-for="item in [{value:'subject',label:'练习题'}]"
              :label="item.value"
          >{{ item.label }}
          </el-radio>
        </el-radio-group>
      </div>

      <el-form
          ref="form"
          :model="formData"
          :rules="rules"
          size="mini"
          label-width="90px"
      >
        <LessonContentCommon
            ref="refLessonContent1"
            v-show="lessonContentType === 'content'"
        ></LessonContentCommon>
        <LessonContentSubject
            ref="refLessonContent2"
            :dialogTitle="dialogTitle"
            v-show="lessonContentType !== 'content'"
        ></LessonContentSubject>
      </el-form>

      <template v-if="addType === 'add'">
        <div class="footer">
          <div>
            <el-button @click="handleSave">保存并关闭</el-button>
          </div>
          <div>
            <el-button type="primary" @click="handleAdd">继续添加</el-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="footer">
          <el-button type="primary" @click="handleFinished">完成</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {addLessonContentMixins} from "@/pages/MyOutLine/addLessonContentMixins";
import {MODULE_TYPE, CONTENT_TYPE} from "@/utils/constants";
import LessonContentCommon from "@/pages/MyOutLine/components/LessonContentCommon.vue";
import LessonContentSubject from "@/pages/MyOutLine/components/LessonContentSubject.vue";

export default {
  name: "AddLessonContentModal",
  props: {
    addType: {
      type: String,
      default: "add",
    },
  },
  components: {
    LessonContentCommon,
    LessonContentSubject,
  },
  mixins: [addLessonContentMixins],
  data() {
    const 内容文件选项 = Object.keys(MODULE_TYPE).map((key) => {
      return {
        value: key,
        label: MODULE_TYPE[key],
      };
    });

    const 内容类型选项 = Object.keys(CONTENT_TYPE).map((key) => {
      return {
        value: key,
        label: CONTENT_TYPE[key],
      };
    });

    return {
      lessonContentType: "content",
      type: "",
      blankWarning: false,
      markDownCheckBoxVal: false,
      creatAudioLoading: false,
      creatSayAudioLoading: false,
      loading: false,
      loadingA: false,
      loadingB: false,
      isLast: false,
      isSituational: false,
      dialogTitle: "",
      contentTypeArr: [...内容类型选项],
      // 切换的九个按钮
      内容文件选项: [...内容文件选项],
      //音频讲解
      humanOption: [
        {
          label: "老师",
          value: "zhiyuan",
        },
        {
          label: "学生",
          value: "zhigui",
        },
        {
          label: "标准女生",
          value: "sijia",
        },
        {
          label: "沉稳男生",
          value: "stanley",
        },
      ],
      rateArr: [
        {
          label: "慢",
          value: 0.8,
        },
        {
          label: "正常",
          value: 1.0,
        },
        {
          label: "快",
          value: 1.2,
        },
      ],
      titleAudioSrc: "",
      // 视频
      videoUrl: "",
      //图片
      imageUrl: "",
      //单选题
      selectTrueOptions: [
        {
          label: "选项A",
          value: 0,
        },
        {
          label: "选项B",
          value: 1,
        },
        {
          label: "选项C",
          value: 2,
        },
        {
          label: "选项D",
          value: 3,
        },
      ],
      //多选题
      multipleSelectTrueOptions: [
        {
          label: "A",
          value: 0,
        },
        {
          label: "B",
          value: 1,
        },
        {
          label: "C",
          value: 2,
        },
        {
          label: "D",
          value: 3,
        },
        {
          label: "E",
          value: 4,
        },
        {
          label: "F",
          value: 5,
        },
        {
          label: "G",
          value: 6,
        },
        {
          label: "H",
          value: 7,
        },
      ],
      //判断题
      judgeTrueOptions: [
        {
          label: "对",
          value: 0,
        },
        {
          label: "错",
          value: 1,
        },
      ],

      //图片选择
      imageSelectAnswerOptions: [
        {
          label: "A",
          value: 0,
        },
        {
          label: "B",
          value: 1,
        },
      ],
      imageSelectUrlA: "",
      imageSelectUrlB: "",
    };
  },
  watch: {
    "formData.role": async function (newVal) {
      if (newVal === "学生") {
        this.defaultVoiceMethod("zhigui");
      } else {
        this.defaultVoiceMethod("zhiyuan");
      }
    },
  },
  computed: {
    ...mapState("courseCenter", ["editOutLineDetail"]),
    ...mapState("tenant", ["ossUploadObj"]),
    ...mapState("courseCenter", [
      "addLessonContentModalV2Visible",
      "audioDetail",
      "editOutLineDetail",
    ]),
    visible: {
      get() {
        return this.$store.state.courseCenter.addLessonContentModalV2Visible;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "addLessonContentModalV2Visible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("courseCenter", ["setData"]),
    ...mapActions("courseCenter", ["getAudioUrl"]),
    ...mapActions("tenant", ["generalUploadUrl"]),
    // ...mapMutations("polyPhone", ["setData"]),
    //点击转音频题干
    // handleToggleVideo(type, text) {
    //   // 文字转音频
    //   if (type === 1) {
    //     if (text && text.trim().length !== 0) {
    //       this.$message.warning("当前题干内容不为空，请清空后切换题干类型!");
    //       return;
    //     }
    //     this.formData.lessonContentTemplate.question.title = "";
    //     this.formData.lessonContentTemplate.question.titleAudio =
    //       "{{titleAudio}}";
    //   } else {
    //     // 音频转文字
    //     if (
    //       (text && text.trim().length !== 0) ||
    //       this.formData.lessonContentTemplate.materials[0].materialUrl
    //     ) {
    //       this.$message.warning("当前题干内容不为空，请清空后切换题干类型!");
    //       return;
    //     }
    //     this.formData.lessonContentTemplate.materials[0].audioText = "";
    //     this.formData.lessonContentTemplate.question.titleAudio = "";
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.form.clearValidate();
    //   });
    // },
    handleDeleteTitleAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.material.materialUrl = "";
            this.formData.lessonContentTemplate.material.materialId = null;
            this.formData.lessonContentTemplate.material.duration = null;
            this.formData.lessonContentTemplate.material.filename = "";
            this.formData.lessonContentTemplate.material.audioText = "";
            this.formData.lessonContentTemplate.material.audioSsmlText = "";
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    handleMarkDown(val) {
      if (val) {
        this.formData.lessonContentTemplate.material.markFlag = 1;
      } else {
        this.formData.lessonContentTemplate.material.markFlag = 0;
      }
    },
    handleChange(val) {
      this.formData.lessonContentTemplate.materials[0].audioText = val;
    },
    // 视频
    beforeUploadVideo(file) {
      if (file.name.split(".")[1].toLowerCase() !== "mp4") {
        this.$message.error("上传视频仅支持mp4格式");
        return false; // 终止上传
      }
    },
    async handleVideoChange(file) {
      this.loading = true;
      const isJPG = file.raw.name.split(".")[1].toLowerCase();
      if (isJPG !== "mp4") {
        this.$message.error("上传视频只能是 MP4格式!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.videoUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            // 获取视频时长
            const video = document.createElement("video");
            video.src = URL.createObjectURL(file.raw);
            video.addEventListener("loadedmetadata", () => {
              if (Math.floor(video.duration) === 0) {
                this.formData.lessonContentTemplate.materials[0].duration = 1;
              } else {
                this.formData.lessonContentTemplate.materials[0].duration =
                    Math.floor(video.duration);
              }
            });
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("视频上传失败，请重新上传");
            this.videoUrl = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    handleUploadNewVideo() {
      this.videoUrl = "";
    },
    //图片
    async handleImgChange(file) {
      this.loading = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loading = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.imageUrl = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[0].filename =
                this.ossUploadObj.filename;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error("图片上传失败，请重新上传");
            this.imageUrl = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImageUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    handleGroupTitleAudioPolyPhone() {
      this.type = "question";
      const inputVal =
          this.formData.lessonContentTemplate.materials[0].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.setData({key: "polyPhoneModalVisible", value: true});
    },
    //选择 判断图 排序 图片选择  生成音频
    async handleGroupTitleAudio() {
      const inputVal =
          this.formData.lessonContentTemplate.materials[0].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.creatAudioLoading = true;
      if (!this.formData.lessonContentTemplate.materials[0].audioText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      this.formData.lessonContentTemplate.materials[0].audioSsmlText =
          this.creatSsmlText(
              this.formData.lessonContentTemplate.materials[0].audioText
          );
      if (!this.formData.lessonContentTemplate.materials[0].audioSsmlText) {
        this.$message.warning("当前题干为空,不支持转音频");
        this.creatAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: this.formData.lessonContentTemplate.materials[0].audioSsmlText,
        speechRate: this.formData.lessonContentTemplate.materials[0].speechRate,
        voice: this.formData.lessonContentTemplate.materials[0].voice,
      });
      //音频url
      this.titleAudioSrc = this.audioDetail.url;
      // 媒体名称
      this.formData.lessonContentTemplate.materials[0].filename =
          this.audioDetail.filename;
      // 媒体ID
      this.formData.lessonContentTemplate.materials[0].materialId =
          this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          this.formData.lessonContentTemplate.materials[0].duration = 1;
        } else {
          this.formData.lessonContentTemplate.materials[0].duration =
              Math.floor(audio.duration);
        }
      });
      // 媒体类型
      this.formData.lessonContentTemplate.materials[0].type =
          this.audioDetail.mimeType;
      // 题目音频类型
      this.formData.lessonContentTemplate.question.titleAudioType =
          this.audioDetail.mimeType;
      // 题目音频url
      this.formData.lessonContentTemplate.materials[0].materialUrl =
          this.audioDetail.url;
      // 题目音频类型
      this.formData.lessonContentTemplate.question.titleAudio =
          "{{titleAudio}}";
      this.creatAudioLoading = false;
    },
    handleDeleteGroupTitleAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.materials[0].materialUrl = "";
            this.formData.lessonContentTemplate.materials[0].audioText = "";
            this.formData.lessonContentTemplate.materials[0].audioSsmlText = "";
            this.formData.lessonContentTemplate.materials[0].filename = "";
            this.formData.lessonContentTemplate.materials[0].materialId = null;
            this.formData.lessonContentTemplate.materials[0].duration = null;
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    handleSelectAnswer(val) {
      const selectItem = this.formData.lessonContentTemplate.question.item[val];
      if (!selectItem || selectItem.trim().length < 1) {
        this.$confirm("您选择的正确选项内容为空,请检查后重试!", "提示", {
          confirmButtonText: "确定",
          showCancelButton: false,
          type: "warning",
        })
            .then(async () => {
            })
            .catch(() => {
            });
        this.formData.lessonContentTemplate.question.answer = [];
      }
    },
    async handleImgSelectChangeA(file) {
      this.loadingA = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loadingA = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.imageSelectUrlA = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[1].filename =
                this.ossUploadObj.filename;
            this.loadingA = false;
          })
          .catch((e) => {
            this.loadingA = false;
            this.$message.error("上传失败，请重新上传！");
            this.imageSelectUrlA = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImgSelectUploadA(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/GIF!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //B选项
    async handleImgSelectChangeB(file) {
      this.loadingB = true;
      const isJPG =
          file.raw.type === "image/jpeg" ||
          file.raw.type === "image/png" ||
          file.raw.type === "image/gif";
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG/GIF!");
        this.loadingB = false;
        return;
      }
      await this.generalUploadUrl({
        contentType: file.raw.type,
      });
      const fileName = encodeURIComponent(file.raw.name);
      // this.form.avatar = this.ossUploadObj.filename
      const obj = {
        "Content-Disposition": "attachment;filename=" + '"' + fileName + '"',
        "Content-Type": file.raw.type,
      };
      this.$axios.defaults.withCredentials = false;
      await this.$axios({
        url: this.ossUploadObj.url,
        method: "put",
        isUpload: true,
        data: file.raw,
        headers: obj,
      })
          .then((res) => {
            this.imageSelectUrlB = URL.createObjectURL(file.raw);
            this.formData.lessonContentTemplate.materials[2].filename =
                this.ossUploadObj.filename;
            this.loadingB = false;
          })
          .catch((e) => {
            this.loadingB = false;
            this.$message.error("上传失败，请重新上传！");
            this.imageSelectUrlB = "";
          });
      this.$axios.defaults.withCredentials = true;
    },
    beforeImgSelectUploadB(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 图片正确选项发生变化时候
    handleImageTrueAnswer() {
      if (!this.imageSelectUrlA || !this.imageSelectUrlB) {
        this.$message.warning("请先补充选项");
        this.formData.lessonContentTemplate.question.answer = [];
      }
    },
    //讲解
    handleChangeSayAudio(val) {
      this.formData.lessonContentTemplate.materials[3].audioText = val;
    },
    handleSayAudioPolyPhone() {
      this.type = "explain";
      const inputVal =
          this.formData.lessonContentTemplate.materials[3].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length < 1 || this.inputValArr.length > 300) {
        return;
      }
      this.setData({key: "polyPhoneModalVisible", value: true});
    },
    async handleSayAudio() {
      const inputVal =
          this.formData.lessonContentTemplate.materials[3].audioText;
      this.inputValArr = this.convertToObjects(inputVal);
      if (this.inputValArr.length > 300) {
        return;
      }
      this.creatSayAudioLoading = true;
      if (!this.formData.lessonContentTemplate.materials[3].audioText) {
        this.$message.warning("当前音频讲解内容为空,不支持转音频");
        this.creatSayAudioLoading = false;
        return;
      }
      this.formData.lessonContentTemplate.materials[3].audioSsmlText =
          this.creatSsmlText(
              this.formData.lessonContentTemplate.materials[3].audioText
          );
      if (!this.formData.lessonContentTemplate.materials[3].audioSsmlText) {
        this.$message.warning("当前音频讲解内容为空,不支持转音频");
        this.creatSayAudioLoading = false;
        return;
      }
      await this.getAudioUrl({
        text: this.formData.lessonContentTemplate.materials[3].audioSsmlText,
        speechRate: this.formData.lessonContentTemplate.materials[3].speechRate,
        voice: this.formData.lessonContentTemplate.materials[3].voice,
      });
      // 媒体名称
      this.formData.lessonContentTemplate.materials[3].filename =
          this.audioDetail.filename;
      // 媒体ID
      this.formData.lessonContentTemplate.materials[3].materialId =
          this.audioDetail.id;
      // 音频时长
      const audio = document.createElement("video");
      audio.src = this.audioDetail.url;
      audio.addEventListener("loadedmetadata", () => {
        if (Math.floor(audio.duration) === 0) {
          this.formData.lessonContentTemplate.materials[3].duration = 1;
        } else {
          this.formData.lessonContentTemplate.materials[3].duration =
              Math.floor(audio.duration);
        }
      });
      // 媒体类型
      this.formData.lessonContentTemplate.materials[3].type =
          this.audioDetail.mimeType;
      // 讲解音频类型
      this.formData.lessonContentTemplate.materials[3].materialUrl =
          this.audioDetail.url;
      // 讲解音频类型
      this.formData.lessonContentTemplate.question.explainAudioType =
          this.audioDetail.mimeType;
      // 占位符
      this.formData.lessonContentTemplate.question.explainAudio =
          "{{explainAudio}}";
      this.creatSayAudioLoading = false;
    },
    handleDeleteSayAudio() {
      this.$confirm("请确认是否要清除当前音频内容?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            this.formData.lessonContentTemplate.materials[3].materialUrl = "";
            this.formData.lessonContentTemplate.materials[3].materialId = null;
            this.formData.lessonContentTemplate.materials[3].duration = null;
            this.formData.lessonContentTemplate.materials[3].filename = "";
            this.formData.lessonContentTemplate.materials[3].audioText = "";
            this.formData.lessonContentTemplate.materials[3].audioSsmlText = "";
            if (this.formData.role === "学生") {
              this.defaultVoiceMethod("zhigui");
            } else {
              this.defaultVoiceMethod("zhiyuan");
            }
          })
          .catch(() => {
          });
    },
    // 本本本本
    handleOpen() {
      this.clearForm();
      this.initForm();
      if (this.type === "audioText") {
        this.$refs.audioTextEdit.blurEditor();
      }
      if (this.type === "question") {
        this.$refs.questionEdit.blurEditor();
      }
      if (this.type === "explain") {
        this.$refs.explainEdit.blurEditor();
      }
    },
    // },
    // 声音属性默方法
    defaultVoiceMethod(voice) {
      if (this.isSituational) {
        this.formData.lessonContentTemplate.materials[3].voice = voice;
        this.formData.lessonContentTemplate.materials[3].speechRate = 1.0;
      }
      if (
          this.formData.type === "select" ||
          this.formData.type === "multipleSelect" ||
          this.formData.type === "judge" ||
          this.formData.type === "sort" ||
          this.formData.type === "text" ||
          this.formData.type === "imageSelect"
      ) {
        this.formData.lessonContentTemplate.materials[0].voice = voice;
        this.formData.lessonContentTemplate.materials[0].speechRate = 1.0;
      }
      if (this.formData.type === "audioText") {
        this.formData.lessonContentTemplate.material.voice = voice;
        this.formData.lessonContentTemplate.material.speechRate = 1.0;
      }
    },
    getCommitFormData() {
      let formData = {};
      if (this.lessonContentType === "content") {
        formData = this.$refs.refLessonContent1.getFormData();
        // formData.modelId = 1;
        // formData.model = "正文";
        formData.lessonContentTemplate.material.type = formData.contentPattern;
        formData.type = formData.lessonContentTemplate.material.type;
      } else {
        formData = this.$refs.refLessonContent2.getFormData();
        // formData.modelId = 2;
        // formData.model = "练习题";
        formData.type = "subject";
        let value = formData.lessonContentTemplate.question.type;
        if ("judge" === value) {
          formData.lessonContentTemplate.question.item = [];
          formData.lessonContentTemplate.question.answer.length = 1;
        } else if ("select" === value) {
          formData.lessonContentTemplate.question.answer.length = 1;
        }
        let materialIds = new Set();
        if (formData.lessonContentTemplate.text) {
          formData.lessonContentTemplate.text.item.forEach(item => {
            materialIds.add(item);
          })
        }
        if (formData.lessonContentTemplate.question) {
          formData.lessonContentTemplate.question.item.forEach(item => {
            item.split(",").forEach((item) => {
              materialIds.add(item);
            })
          })

          if (formData.lessonContentTemplate.question.title) {
            let strings = formData.lessonContentTemplate.question.title.split(",");
            strings.forEach(item => {
              materialIds.add(item);
            })
          }

          if (formData.lessonContentTemplate.question.explain) {
            let strings = formData.lessonContentTemplate.question.explain.split(",");
            strings.forEach(item => {
              materialIds.add(item);
            })
          }
        }
        formData.lessonContentTemplate.materials = formData.lessonContentTemplate.materials.filter(item => materialIds.has(item.id + ""))
      }


      formData.lessonContentType = this.lessonContentType;
      formData.lessonContentTemplate.contentType = this.lessonContentType;
      formData.modelId = this.formData.modelId;
      formData.model = this.editOutLineDetail.outline.find(item => item.id === this.formData.modelId)?.module;
      return formData;
    },
    //保存查看
    async handleSave() {
      this.formData = this.getCommitFormData();
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommitV2();
          if (res) {
            if (this.addType === "downAdd") {
              this.formData.operateOffset = JSON.parse(
                  localStorage.getItem("operateOffset")
              );
              await this.addBelowLessonContent({
                ...this.formData,
              });
            } else {
              await this.saveLessonContent({
                ...this.formData,
              });
            }
            this.$message.success("操作成功");
            await this.$emit("initTable");
            this.setData({
              key: "addLessonContentModalV2Visible",
              value: false,
            });
          }
        }
      });
    },
    //继续添加
    async handleAdd() {
      this.formData = this.getCommitFormData();
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommitV2();
          if (res) {
            if (this.addType === "downAdd") {
              this.formData.operateOffset = JSON.parse(
                  localStorage.getItem("operateOffset")
              );
              await this.addBelowLessonContent({
                ...this.formData,
              });
            } else {
              await this.saveLessonContent({
                ...this.formData,
              });
            }
            this.$message.success("操作成功");
            await this.$emit("initTable");
            await this.clearForm();
            this.initForm();
          }
        }
      });
    },
    //进入下一模块
    async handleNextModule() {
      this.formData = this.getCommitFormData();
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommitV2();
          if (res) {
            await this.saveLessonContent({
              ...this.formData,
            });
            await this.$emit("initTable");
            this.$message.success("操作成功");
            let index = JSON.parse(localStorage.getItem("moduleIndex")) + 1;
            localStorage.setItem("moduleIndex", JSON.stringify(index));
            localStorage.setItem(
                "modelItem",
                JSON.stringify(this.editOutLineDetail.outline[index])
            );
            this.clearForm();
            this.initForm();
            this.$emit("activeItem");
            await this.$emit("initTable");
            if (index + 1 === this.editOutLineDetail.outline.length) {
              this.isLast = true;
            }
          }
        }
      });
    },
    // 最后一个完成按钮
    async handleFinished() {
      this.formData = this.getCommitFormData();
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await this.handleCommitV2();
          if (res) {
            if (this.addType === "downAdd") {
              this.formData.operateOffset = JSON.parse(
                  localStorage.getItem("operateOffset")
              );
              await this.addBelowLessonContent({
                ...this.formData,
              });
            } else {
              await this.saveLessonContent({
                ...this.formData,
              });
            }
            this.$message.success("操作成功");
            await this.$emit("initTable");
            await this.setData({
              key: "addLessonContentModalV2Visible",
              value: false,
            });
          }
        }
      });
    },
    //初始化表单方法，包括回显、清空等
    initForm() {
      let index = JSON.parse(localStorage.getItem("moduleIndex"));
      this.isLast = index + 1 === this.editOutLineDetail.outline.length;

      //this.$nextTick(() => {
      //  this.$refs.form.clearValidate();
      //});

      this.formData.addTyoe = this.addType;
      this.formData.role = "老师";
      const 内容文件选项 = Object.keys(MODULE_TYPE).map((key) => {
        return {
          value: key,
          label: MODULE_TYPE[key],
        };
      });
      this.内容文件选项 = 内容文件选项;
      if (this.addType === "add") {
        const modelItem = JSON.parse(localStorage.getItem("modelItem"));
        //判断是否是随堂测试环节，如果是，则所有题题型有错题讲解
        this.isSituational = modelItem.module === "随堂测试";
        let modelType;
        // 判断是否是用户自定义的大纲
        if (modelItem.type === "custom") {
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
          this.内容文件选项 = this.内容文件选项.slice(
              0,
              this.内容文件选项.length - 1
          );
        } else {
          // 判断是否有多种表现形式
          if (modelItem.type.indexOf(",") === -1) {
            modelType = modelItem.type.split();
          } else {
            modelType = modelItem.type.split(",");
          }
          // 转成数组后，过滤出来当前表现形式的数组，进行赋值
          const arr = this.内容文件选项.filter((item1) =>
              modelType.some((item2) => item1.value === item2)
          );
          this.内容文件选项 = arr;
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
          this.formData.role = "老师";
        }
        this.formData.type = "audioText";
        this.defaultVoiceMethod("zhiyuan");
        this.formData.contentPattern = "audioText";
        this.formData.subjectType = "select";
        this.formData.lessonContentTemplate.version = 2;
        this.markDownCheckBoxVal = false;
        this.formData.editMode = "add";

        if (this.dialogTitle === "引入") {
          this.lessonContentType = "content";
        } else if (this.dialogTitle === "随堂测试") {
          this.lessonContentType = "subject";
        }
      } else if (this.addType === "edit" || this.addType === "view") {
        const lessonContentRow = JSON.parse(
            localStorage.getItem("lessonContentRow")
        );
        var lessonContentDetail;
        lessonContentRow.contentPattern = "audioText";
        lessonContentDetail = JSON.parse(JSON.stringify(lessonContentRow));
        const arr = this.内容文件选项.filter(
            (item) => item.value === lessonContentDetail.type
        );
        this.内容文件选项 = arr;
        //判断是否是随堂测试环节，如果是，则所有题题型有错题讲解
        this.isSituational = lessonContentDetail.model === "随堂测试";
        this.formData.id = lessonContentDetail.id;
        this.formData.type = lessonContentDetail.type;
        //if(this.formData.contentType == undefined){
        //  this.formData.contentType = 'audioText';
        //}
        //this.formData.contentType = 'audioText';
        this.formData.contentType = lessonContentDetail.contentType;

        this.formData.model = lessonContentDetail.model;
        this.formData.modelId = lessonContentDetail.modelId;
        this.formData.lessonId = lessonContentDetail.lessonId;
        this.formData.version = lessonContentDetail.version;
        this.dialogTitle = lessonContentDetail.model;
        this.formData.role = lessonContentDetail.content.role;

        this.formData.lessonContentTemplate = lessonContentDetail.content;

        if (
            lessonContentDetail.type === "image" ||
            lessonContentDetail.type === "richText"
        ) {
          this.imageUrl = lessonContentDetail.content.materials[0].materialUrl;
        }
        if (lessonContentDetail.type === "sort") {
          // this.sortTrueAnswer =
          //   this.formData.lessonContentTemplate.question.answer.join(",");
        }
        if (lessonContentDetail.type === "imageSelect") {
          this.imageSelectUrlA =
              lessonContentDetail.content.materials[1].materialUrl;
          this.imageSelectUrlB =
              lessonContentDetail.content.materials[2].materialUrl;
        }
        if (lessonContentDetail.type === "video") {
          this.videoUrl = lessonContentDetail.content.materials[0].materialUrl;
        }
        if (
            this.formData.type === "text" ||
            this.formData.type === "dialogSelect"
        ) {
          this.formData.role = "学生";
        }

        this.lessonContentType =
            this.formData.lessonContentTemplate.contentType;
        if (this.lessonContentType === "content") {
          this.formData.contentPattern =
              this.formData.lessonContentTemplate.material.type;
        }

        this.markDownCheckBoxVal =
            this.formData.type === "audioText" &&
            this.formData.lessonContentTemplate.material.markFlag === 1;
        this.formData.editMode = "edit";
      } else if (this.addType === "downAdd") {
        const modelItem = JSON.parse(localStorage.getItem("modelItem"));
        //判断是否是随堂测试环节，如果是，则所有题题型有错题讲解
        if (modelItem.module === "随堂测试") {
          this.isSituational = true;
        } else {
          this.isSituational = false;
        }
        let modelType;
        // 判断是否是用户自定义的大纲
        if (modelItem.type === "custom") {
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
          this.内容文件选项 = this.内容文件选项.slice(
              0,
              this.内容文件选项.length - 1
          );
        } else {
          // 判断是否有多种表现形式
          if (modelItem.type.indexOf(",") === -1) {
            modelType = modelItem.type.split();
          } else {
            modelType = modelItem.type.split(",");
          }
          // 转成数组后，过滤出来当前表现形式的数组，进行赋值
          const arr = this.内容文件选项.filter((item1) =>
              modelType.some((item2) => item1.value === item2)
          );
          this.内容文件选项 = arr;
          this.formData.type = this.内容文件选项[0].value;
          this.formData.model = modelItem.module;
          this.formData.modelId = modelItem.id;
          this.formData.lessonId = this.editOutLineDetail.lessonId;
          this.formData.version = this.editOutLineDetail.version;
          this.dialogTitle = modelItem.module;
        }

        this.formData.type = "audioText";
        this.defaultVoiceMethod("zhiyuan");
        this.formData.contentPattern = "audioText";
        this.formData.subjectType = "select";
        this.formData.lessonContentTemplate.version = 2;

        if (
            this.formData.type === "text" ||
            this.formData.type === "dialogSelect"
        ) {
          this.formData.role = "学生";
        }
        this.markDownCheckBoxVal =
            this.formData.type === "audioText" &&
            this.formData.lessonContentTemplate.material.markFlag === 1;
        this.formData.editMode = "downAdd";
        if (this.dialogTitle === "引入") {
          this.lessonContentType = "content";
        } else if (this.dialogTitle === "随堂测试") {
          this.lessonContentType = "subject";
        }
      }

      this.$refs.refLessonContent1.initFormData(this.formData);
      this.$refs.refLessonContent2.initFormData(this.formData);
    },
    // 返回纯文本数组
    convertToObjects(inputVal) {
      const objects = [];
      if (!inputVal) {
        return objects;
      }
      const regex = /(<strong.*?>.*?<\/strong>)|./g;
      const result = inputVal.match(regex);
      var newResult = [];
      for (let i = 0; i < result.length; i++) {
        if (result[i].trim().length > 1) {
          if (!result[i].includes("color: rgb(16, 104, 156)")) {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push(text);
          } else {
            const div = document.createElement("div");
            div.innerHTML = result[i];
            let text = div.textContent || div.innerText;
            newResult.push("{{{" + text + "}}}");
          }
        } else {
          newResult.push(result[i]);
        }
      }
      const str = newResult.join("");
      const div = document.createElement("div");
      div.innerHTML = str;
      let newStr = div.textContent || div.innerText;
      const regex2 = /({{{.*?}}})|./g;
      const result2 = newStr.match(regex2);
      for (let i = 0; i < result2.length; i++) {
        const item = result2[i];
        if (item.length > 1) {
          const regex = /\{\{\{(.+?)\}\}\}/g;
          const match = item.replace(regex, "$1");
          if (match && match.length >= 2) {
            const extractedText = match.trim();
            const cha = extractedText.split("]")[1];
            const pinyin = extractedText.split("]")[0].split("[")[1];
            objects.push({cha: cha, pinyin: pinyin});
          }
        } else {
          objects.push({cha: item, pinyin: ""});
        }
      }
      return objects;
    },
    // 解析为ssml文本，生成音频
    creatSsmlText(val) {
      const characterArr = this.convertToObjects(val);
      if (characterArr.length < 1) {
        return "";
      }
      const ssmlText = characterArr
          .map((item) => {
            if (item.pinyin !== "") {
              return `<phoneme alphabet='py' ph='${item.pinyin}'>${item.cha}</phoneme>`;
            } else {
              return item.cha;
            }
          })
          .join("");
      return "<speak>" + ssmlText + "</speak>";
    },
    // 多音字不可编辑部分
    disabledEdit() {
      let paragraphs = document.querySelectorAll("p");
      paragraphs.forEach(function (paragraph) {
        let strongArr = paragraph.querySelectorAll("strong");
        strongArr.forEach(function (strong) {
          if (getComputedStyle(strong).color === "rgb(16, 104, 156)") {
            strong.setAttribute("contenteditable", "false");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.AddLessonContentModal {
  ::v-deep .el-dialog {
    min-width: 900px;
    height: 800px;
  }

  ::v-deep .el-dialog .el-dialog__body {
    padding: 20px 35px;
  }

  ::v-deep .el-dialog__close {
    z-index: 999;
  }

  ::v-deep .el-form-item {
    margin-bottom: 10px !important;
  }

  ::v-deep .el-button--primary.is-plain {
    color: #10689c;
    background: #f0f2fa;
    border-color: #c1cbea;
  }

  ::v-deep .el-button--primary.is-plain:hover {
    color: #10689c;
    background: #f0f2fa;
    border-color: #c1cbea;
  }

  ::v-deep .el-button--info.is-plain {
    color: #8f8f8f;
    background: #f4f4f4;
    border-color: #d2d2d2;
  }

  ::v-deep .el-button--info.is-plain:hover {
    color: #8f8f8f;
    background: #f4f4f4;
    border-color: #d2d2d2;
  }

  .sortBox {
    .requiredSort {
      ::v-deep .el-input__inner {
        border: 1px solid #f56c6c;
      }
    }

    ::v-deep .el-form-item__label::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }

  .title {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .contentChangeBox {
    background: #f2f2f2;
    padding: 15px 10px 10px 0;
    border-radius: 3px;
    margin-top: 15px;
    min-height: 310px;

    ::v-deep .el-form-item {
      margin-bottom: 15px !important;
    }

    .unShowStar {
      ::v-deep
      .el-form-item.is-required:not(.is-no-asterisk)
      > .el-form-item__label:before {
        content: "";
      }
    }

    .itemBox {
      width: 100%;
      background: #ffffff;
      padding: 10px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }

    //题干转音频
    .changeTitleTypeBox {
      margin-left: 90px;
      margin-top: 20px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    ::v-deep .el-textarea__inner {
      min-height: 100px !important;
    }

    //图片
    .avatar-uploader .el-upload {
      border: 1px solid #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      border: 1px solid #dcdfe6;
      margin-bottom: 20px;
    }

    .avatar {
      width: 100px;
      height: 100px;
      display: block;
      margin-bottom: 10px;
    }

    .btn {
      text-align: right;
    }

    .explainBox {
      .explainTitle {
        width: 83px;
        text-align: right;
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;

        .changeTitleTypeBox1 {
          width: 100%;
          display: flex;
          justify-content: space-between !important;
          align-items: flex-start;
        }
      }
    }
  }

  .footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 20px;
  }
}
</style>
